import { I18n } from "react-redux-i18n";
import StripeChargeSucceededNode from "../../Triggers/StripeChargeSucceeded/StripeChargeSucceededNode";

const contentTextCreator = (attributeName, attributeValue) => {
	if (checkIfWorkFlowVariable(attributeValue)) {
		attributeValue = I18n._translate(
			"app-automation-editor_events_action-3_tile-workflow-variable");
	}
	if (checkIfStripeInputVariable(attributeValue)) {
		const extracted = attributeValue.match(/\.\w+\}$/)?.[0]?.replace(/[.\}]/g, '');
		attributeValue = extracted ? extracted : attributeValue;
	}
	if (checkIfIncrementAttributeVariable(attributeValue))
		return I18n._translate("app-automation-editor_events_action-3_tile-content", {
			name: attributeName,
			value: attributeName + "+ 1",
		});
	return I18n._translate("app-automation-editor_events_action-3_tile-content", {
		name: attributeName,
		value: attributeValue,
	});
};

const checkIfWorkFlowVariable = (attributeValue) => {
	const pattern = /\$\{time\.format\(sys\.now\(\),\s*\"[^\"]+\"\)\}/;

	return pattern.test(attributeValue);

};

const checkIfStripeInputVariable = (attributeValue) => {
	return attributeValue.startsWith('${input.data');
};

const checkIfIncrementAttributeVariable = (attributeValue) => {
	return attributeValue.startsWith('${int');
};

const getBottomLevelAttributes = (charge, result) => {
	// Loop through each key in the current object
	let obj = charge;
	for (const key in obj) {
		if (obj.hasOwnProperty(key)) {
			const value = obj[key];

			// Check if the value is an object (and not null)
			if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
				// Recursively call the function to go deeper
				getBottomLevelAttributes(value, result);
			} else {
				// If it's not an object, it's a bottom-level attribute
				result[key] = value;
			}
		}
	}
	return result;
};

const chargeSuceededEventInput = () => {
	return {
		"charge": {
			"amount": "${input.data.charge.amount}",
			"amount_captured": "${input.data.charge.amount_captured}",
			"amount_refunded": "${input.data.charge.amount_refunded}",
			"application": "${input.data.charge.application}",
			"application_fee": "${input.data.charge.application_fee}",
			"application_fee_amount": "${input.data.charge.application_fee_amount}",
			"balance_transaction": "${input.data.charge.balance_transaction}",
			"billing_details": {
				"address": {
					"city": "${input.data.charge.billing_details.address.city}",
					"country": "${input.data.charge.billing_details.address.country}",
					"line1": "${input.data.charge.billing_details.address.line1}",
					"line2": "${input.data.charge.billing_details.address.line2}",
					"postal_code": "${input.data.charge.billing_details.address.postal_code}",
					"state": "${input.data.charge.billing_details.address.state}"
				},
				"email": "${input.data.charge.billing_details.email}",
				"name": "${input.data.charge.billing_details.name}",
				"phone": "${input.data.charge.billing_details.phone}"
			},
			"calculated_statement_descriptor": "${input.data.charge.calculated_statement_descriptor}",
			"captured": "${input.data.charge.captured}",
			"created": "${input.data.charge.created}",
			"currency": "${input.data.charge.currency}",
			"customer": "${input.data.charge.customer}",
			"description": "${input.data.charge.description}",
			"destination": "${input.data.charge.destination}",
			"dispute": "${input.data.charge.dispute}",
			"disputed": "${input.data.charge.disputed}",
			"failure_balance_transaction": "${input.data.charge.failure_balance_transaction}",
			"failure_code": "${input.data.charge.failure_code}",
			"failure_message": "${input.data.charge.failure_message}",
			"fraud_details": "${input.data.charge.fraud_details}",
			"id": "${input.data.charge.id}",
			"invoice": "${input.data.charge.invoice}",
			"livemode": "${input.data.charge.livemode}",
			"metadata": "${input.data.charge.metadata}",
			"object": "${input.data.charge.object}",
			"on_behalf_of": "${input.data.charge.on_behalf_of}",
			"order": "${input.data.charge.order}",
			"outcome": {
				"network_status": "${input.data.charge.outcome.network_status}",
				"reason": "${input.data.charge.outcome.reason}",
				"risk_level": "${input.data.charge.outcome.risk_level}",
				"risk_score": "${input.data.charge.outcome.risk_score}",
				"seller_message": "${input.data.charge.outcome.seller_message}",
				"type": "${input.data.charge.outcome.type}"
			},
			"paid": "${input.data.charge.paid}",
			"payment_intent": "${input.data.charge.payment_intent}",
			"payment_method": "${input.data.charge.payment_method}",
			"payment_method_details": {
				"card": {
					"amount_authorized": "${input.data.charge.payment_method_details.card.amount_authorized}",
					"authorization_code": "${input.data.charge.payment_method_details.card.authorization_code}",
					"brand": "${input.data.charge.payment_method_details.card.brand}",
					"checks": {
						"address_line1_check": "${input.data.charge.payment_method_details.card.checks.address_line1_check}",
						"address_postal_code_check": "${input.data.charge.payment_method_details.card.checks.address_postal_code_check}",
						"cvc_check": "${input.data.charge.payment_method_details.card.checks.cvc_check}"
					},
					"country": "${input.data.charge.payment_method_details.card.country}",
					"exp_month": "${input.data.charge.payment_method_details.card.exp_month}",
					"exp_year": "${input.data.charge.payment_method_details.card.exp_year}",
					"extended_authorization": {
						"status": "${input.data.charge.payment_method_details.card.extended_authorization.status}"
					},
					"fingerprint": "${input.data.charge.payment_method_details.card.fingerprint}",
					"funding": "${input.data.charge.payment_method_details.card.funding}",
					"incremental_authorization": {
						"status": "${input.data.charge.payment_method_details.card.incremental_authorization.status}"
					},
					"installments": "${input.data.charge.payment_method_details.card.installments}",
					"last4": "${input.data.charge.payment_method_details.card.last4}",
					"mandate": "${input.data.charge.payment_method_details.card.mandate}",
					"multicapture": {
						"status": "${input.data.charge.payment_method_details.card.multicapture.status}"
					},
					"network": "${input.data.charge.payment_method_details.card.network}",
					"network_token": {
						"used": "${input.data.charge.payment_method_details.card.network_token.used}"
					},
					"overcapture": {
						"maximum_amount_capturable": "${input.data.charge.payment_method_details.card.overcapture.maximum_amount_capturable}",
						"status": "${input.data.charge.payment_method_details.card.overcapture.status}"
					},
					"three_d_secure": "${input.data.charge.payment_method_details.card.three_d_secure}",
					"wallet": "${input.data.charge.payment_method_details.card.wallet}"
				},
				"type": "${input.data.charge.payment_method_details.type}"
			},
			"radar_options": "${input.data.charge.radar_options}",
			"receipt_email": "${input.data.charge.receipt_email}",
			"receipt_number": "${input.data.charge.receipt_number}",
			"receipt_url": "${input.data.charge.receipt_url}",
			"refunded": "${input.data.charge.refunded}",
			"review": "${input.data.charge.review}",
			"shipping": "${input.data.charge.shipping}",
			"source": "${input.data.charge.source}",
			"source_transfer": "${input.data.charge.source_transfer}",
			"statement_descriptor": "${input.data.charge.statement_descriptor}",
			"statement_descriptor_suffix": "${input.data.charge.statement_descriptor_suffix}",
			"status": "${input.data.charge.status}",
			"transfer_data": "${input.data.charge.transfer_data}",
			"transfer_group": "${input.data.charge.transfer_group}"
		}

	};
};

const customerFromStripeInput = () => {
	return {
		"customer": {
			"address": "${input.data.customer.address}",
			"balance": "${input.data.customer.balance}",
			"created": "${input.data.customer.created}",
			"currency": "${input.data.customer.currency}",
			"default_source": "${input.data.customer.default_source}",
			"delinquent": "${input.data.customer.delinquent}",
			"description": "${input.data.customer.description}",
			"discount": "${input.data.customer.discount}",
			"email": "${input.data.customer.email}",
			"id": "${input.data.customer.id}",
			"invoice_prefix": "${input.data.customer.invoice_prefix}",
			"invoice_settings": {
				"custom_fields": "${input.data.customer.invoice_settings.custom_fields}",
				"default_payment_method": "${input.data.customer.invoice_settings.default_payment_method}",
				"footer": "${input.data.customer.invoice_settings.footer}",
				"rendering_options": "${input.data.customer.invoice_settings.rendering_options}"
			},
			"livemode": "${input.data.customer.livemode}",
			"metadata": "${input.data.customer.metadata}",
			"name": "${input.data.customer.name}",
			"next_invoice_sequence": "${input.data.customer.next_invoice_sequence}",
			"object": "${input.data.customer.object}",
			"phone": "${input.data.customer.phone}",
			"preferred_locales": "${input.data.customer.preferred_locales}",
			"shipping": "${input.data.customer.shipping}",
			"tax_exempt": "${input.data.customer.tax_exempt}",
			"test_clock": "${input.data.customer.test_clock}"
		}
	};
};

const invoiceFromStripeInput = () => {
	return {
		"invoice": {
			"account_country": "${input.data.invoice.account_country}",
			"account_name": "${input.data.invoice.account_name}",
			"account_tax_ids": "${input.data.invoice.account_tax_ids}",
			"amount_due": "${input.data.invoice.amount_due}",
			"amount_paid": "${input.data.invoice.amount_paid}",
			"amount_remaining": "${input.data.invoice.amount_remaining}",
			"amount_shipping": "${input.data.invoice.amount_shipping}",
			"application": "${input.data.invoice.application}",
			"application_fee_amount": "${input.data.invoice.application_fee_amount}",
			"attempt_count": "${input.data.invoice.attempt_count}",
			"attempted": "${input.data.invoice.attempted}",
			"auto_advance": "${input.data.invoice.auto_advance}",
			"automatic_tax": {
				"enabled": "${input.data.invoice.automatic_tax.enabled}",
				"liability": "${input.data.invoice.automatic_tax.liability}",
				"status": "${input.data.invoice.automatic_tax.status}"
			},
			"automatically_finalizes_at": "${input.data.invoice.automatically_finalizes_at}",
			"billing_reason": "${input.data.invoice.billing_reason}",
			"charge": {
				"amount": "${input.data.charge.amount}"
			},
			"collection_method": "${input.data.invoice.collection_method}",
			"created": "${input.data.invoice.created}",
			"currency": "${input.data.invoice.currency}",
			"custom_fields": "${input.data.invoice.custom_fields}",
			"customer": "${input.data.invoice.customer}",
			"customer_address": "${input.data.invoice.customer_address}",
			"customer_email": "${input.data.invoice.customer_email}",
			"customer_name": "${input.data.invoice.customer_name}",
			"customer_phone": "${input.data.invoice.customer_phone}",
			"customer_shipping": "${input.data.invoice.customer_shipping}",
			"customer_tax_exempt": "${input.data.invoice.customer_tax_exempt}",
			"customer_tax_ids": "${input.data.invoice.customer_tax_ids}",
			"default_payment_method": "${input.data.invoice.default_payment_method}",
			"default_source": "${input.data.invoice.default_source}",
			"default_tax_rates": "${input.data.invoice.default_tax_rates}",
			"description": "${input.data.invoice.description}",
			"discount": "${input.data.invoice.discount}",
			"discounts": "${input.data.invoice.discounts}",
			"due_date": "${input.data.invoice.due_date}",
			"effective_at": "${input.data.invoice.effective_at}",
			"ending_balance": "${input.data.invoice.ending_balance}",
			"footer": "${input.data.invoice.footer}",
			"from_invoice": "${input.data.invoice.from_invoice}",
			"hosted_invoice_url": "${input.data.invoice.hosted_invoice_url}",
			"id": "${input.data.invoice.id}",
			"invoice_pdf": "${input.data.invoice.invoice_pdf}",
			"issuer": {
				"type": "${input.data.invoice.issuer.type}"
			},
			"last_finalization_error": "${input.data.invoice.last_finalization_error}",
			"latest_revision": "${input.data.invoice.latest_revision}",
			"lines": {
				"data": [
					{
						"amount": "${input.data.invoice.lines.data[0].amount}",
						"amount_excluding_tax": "${input.data.invoice.lines.data[0].amount_excluding_tax}",
						"currency": "${input.data.invoice.lines.data[0].currency}",
						"description": "${input.data.invoice.lines.data[0].description}",
						"discount_amounts": "${input.data.invoice.lines.data[0].discount_amounts}",
						"discountable": "${input.data.invoice.lines.data[0].discountable}",
						"discounts": "${input.data.invoice.lines.data[0].discounts}",
						"id": "${input.data.invoice.lines.data[0].id}",
						"invoice": "${input.data.invoice.lines.data[0].invoice}",
						"livemode": "${input.data.invoice.lines.data[0].livemode}",
						"metadata": "${input.data.invoice.lines.data[0].metadata}",
						"object": "${input.data.invoice.lines.data[0].object}",
						"period": {
							"end": "${input.data.invoice.lines.data[0].period.end}",
							"start": "${input.data.invoice.lines.data[0].period.start}"
						},
						"plan": {
							"active": "${input.data.invoice.lines.data[0].plan.active}",
							"aggregate_usage": "${input.data.invoice.lines.data[0].plan.aggregate_usage}",
							"amount": "${input.data.invoice.lines.data[0].plan.amount}",
							"amount_decimal": "${input.data.invoice.lines.data[0].plan.amount_decimal}",
							"billing_scheme": "${input.data.invoice.lines.data[0].plan.billing_scheme}",
							"created": "${input.data.invoice.lines.data[0].plan.created}",
							"currency": "${input.data.invoice.lines.data[0].plan.currency}",
							"id": "${input.data.invoice.lines.data[0].plan.id}",
							"interval": "${input.data.invoice.lines.data[0].plan.interval}",
							"interval_count": "${input.data.invoice.lines.data[0].plan.interval_count}",
							"livemode": "${input.data.invoice.lines.data[0].plan.livemode}",
							"metadata": "${input.data.invoice.lines.data[0].plan.metadata}",
							"meter": "${input.data.invoice.lines.data[0].plan.meter}",
							"nickname": "${input.data.invoice.lines.data[0].plan.nickname}",
							"object": "${input.data.invoice.lines.data[0].plan.object}",
							"product": "${input.data.invoice.lines.data[0].plan.product}",
							"tiers_mode": "${input.data.invoice.lines.data[0].plan.tiers_mode}",
							"transform_usage": "${input.data.invoice.lines.data[0].plan.transform_usage}",
							"trial_period_days": "${input.data.invoice.lines.data[0].plan.trial_period_days}",
							"usage_type": "${input.data.invoice.lines.data[0].plan.usage_type}"
						},
						"price": {
							"active": "${input.data.invoice.lines.data[0].price.active}",
							"billing_scheme": "${input.data.invoice.lines.data[0].price.billing_scheme}",
							"created": "${input.data.invoice.lines.data[0].price.created}",
							"currency": "${input.data.invoice.lines.data[0].price.currency}",
							"custom_unit_amount": "${input.data.invoice.lines.data[0].price.custom_unit_amount}",
							"id": "${input.data.invoice.lines.data[0].price.id}",
							"livemode": "${input.data.invoice.lines.data[0].price.livemode}",
							"lookup_key": "${input.data.invoice.lines.data[0].price.lookup_key}",
							"metadata": "${input.data.invoice.lines.data[0].price.metadata}",
							"nickname": "${input.data.invoice.lines.data[0].price.nickname}",
							"object": "${input.data.invoice.lines.data[0].price.object}",
							"product": "${input.data.invoice.lines.data[0].price.product}",
							"recurring": {
								"aggregate_usage": "${input.data.invoice.lines.data[0].price.recurring.aggregate_usage}",
								"interval": "${input.data.invoice.lines.data[0].price.recurring.interval}",
								"interval_count": "${input.data.invoice.lines.data[0].price.recurring.interval_count}",
								"meter": "${input.data.invoice.lines.data[0].price.recurring.meter}",
								"trial_period_days": "${input.data.invoice.lines.data[0].price.recurring.trial_period_days}",
								"usage_type": "${input.data.invoice.lines.data[0].price.recurring.usage_type}"
							},
							"tax_behavior": "${input.data.invoice.lines.data[0].price.tax_behavior}",
							"tiers_mode": "${input.data.invoice.lines.data[0].price.tiers_mode}",
							"transform_quantity": "${input.data.invoice.lines.data[0].price.transform_quantity}",
							"type": "${input.data.invoice.lines.data[0].price.type}",
							"unit_amount": "${input.data.invoice.lines.data[0].price.unit_amount}",
							"unit_amount_decimal": "${input.data.invoice.lines.data[0].price.unit_amount_decimal}"
						},
						"proration": "${input.data.invoice.lines.data[0].proration}",
						"proration_details": {
							"credited_items": "${input.data.invoice.lines.data[0].proration_details.credited_items}"
						},
						"quantity": "${input.data.invoice.lines.data[0].quantity}",
						"subscription": "${input.data.invoice.lines.data[0].subscription}",
						"subscription_item": "${input.data.invoice.lines.data[0].subscription_item}",
						"tax_amounts": "${input.data.invoice.lines.data[0].tax_amounts}",
						"tax_rates": "${input.data.invoice.lines.data[0].tax_rates}",
						"type": "${input.data.invoice.lines.data[0].type}",
						"unit_amount_excluding_tax": "${input.data.invoice.lines.data[0].unit_amount_excluding_tax}"
					}
				],
				"has_more": "${input.data.invoice.lines.has_more}",
				"object": "${input.data.invoice.lines.object}",
				"total_count": "${input.data.invoice.lines.total_count}",
				"url": "${input.data.invoice.lines.url}"
			},
			"livemode": "${input.data.invoice.livemode}",
			"metadata": "${input.data.invoice.metadata}",
			"next_payment_attempt": "${input.data.invoice.next_payment_attempt}",
			"number": "${input.data.invoice.number}",
			"object": "${input.data.invoice.object}",
			"on_behalf_of": "${input.data.invoice.on_behalf_of}",
			"paid": "${input.data.invoice.paid}",
			"paid_out_of_band": "${input.data.invoice.paid_out_of_band}",
			"payment_intent": "${input.data.invoice.payment_intent}",
			"payment_settings": {
				"default_mandate": "${input.data.invoice.payment_settings.default_mandate}",
			}
		}
	};
};

export { contentTextCreator, checkIfWorkFlowVariable, checkIfStripeInputVariable, getBottomLevelAttributes, customerFromStripeInput, chargeSuceededEventInput, checkIfIncrementAttributeVariable };
